import { createContext } from 'react';

import type { TourTargetId } from './tourTypes';

export interface TourContextValue {
  registerTarget: (id: TourTargetId, element: HTMLElement | null) => void;
}

export const TourContext = createContext<TourContextValue | null>(null);
